import { useState } from 'react';
import { Modal, Button, Input, message } from 'antd';
import baseuri from '../../methods/baseuri';
import { useAppDispatch } from '../../methods/redux/hooks';
import { updateWithdrawalStatus } from '../../methods/redux/reducers/withdrawal-requests';

interface ICompleteRefundedFiatWithdrawalModal {
	request: any;
}

const CompleteRefundedFiatWithdrawalModal = ({
	request,
}: ICompleteRefundedFiatWithdrawalModal) => {
	const dispatch = useAppDispatch();
	const [visible, setVisible] = useState(false);
	const [confirmCode, setConfirmCode] = useState('');
	const [loading, setLoading] = useState(false);

	const submitRefund = async () => {
		if (!confirmCode) {
			message.error('Please enter a confirmation code');
			return;
		}

		try {
			setLoading(true);
			await baseuri.post('/admin/wallet/complete-refunded-fiat-withdrawal', {
				withdrawalId: request._id,
				confirmCode,
			});
			setLoading(false);
			message.success('Refund completed successfully!');
			setVisible(false);
		} catch (e: any) {
			setLoading(false);
			message.error(e?.response?.data?.message || 'An error occurred');
		}
	};

	return (
		<>
			<Button type="primary" onClick={() => setVisible(true)} style={{ marginLeft: '10px' }}>
				Revert to Success
			</Button>

			<Modal
				visible={visible}
				title="Revert Completed transaction back to Succes"
				onCancel={() => setVisible(false)}
				footer={[
					<Button key="back" onClick={() => setVisible(false)}>
						Cancel
					</Button>,
					<Button
						key="submit"
						type="primary"
						loading={loading}
						onClick={submitRefund}
					>
						Submit
					</Button>,
				]}
			>
				<p>Revert Completed transaction back to Success: This will debit the user wallet again since the transaction is lately successful in third party</p>
				<Input
					placeholder="Confirmation Code"
					value={confirmCode}
					onChange={(e) => setConfirmCode(e.target.value)}
				/>
			</Modal>
		</>
	);
};

export default CompleteRefundedFiatWithdrawalModal;
